import { Navigate } from 'react-router-dom';

// Registration and login are the same flow with Google OAuth.
// Redirect all /register traffic to /login.
export function RegisterPage() {
  return <Navigate to="/login" replace />;
}
